import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuid } from 'uuid'

import type { CollectionUUID, Recipe } from '@library/menu-service'

import { actionTypes } from 'actions/actionTypes'
import * as trackingKeys from 'actions/trackingKeys'
import { useCollection } from 'hooks/menu-collections'
import { useMenuMeta } from 'hooks/menu-metadata/useMenuMeta'
import { getBasketDate, getBasketMenuId, getBasketOrderId } from 'selectors/basket'
import { getBoxSummaryDeliveryDays, getMenuBrowseCTAShow } from 'selectors/root'
import { getTransactionType } from 'selectors/tracking'

export function useTrackRecipeListEffect(collectionId: CollectionUUID, recipes: Recipe[]) {
  const dispatch = useDispatch()
  const basketDate = useSelector(getBasketDate)
  const boxSummaryDeliveryDays = useSelector(getBoxSummaryDeliveryDays)
  const transactionType = useSelector(getTransactionType)
  const collection = useCollection(collectionId)
  const currentMenuId = useSelector(getBasketMenuId)
  const orderId = useSelector(getBasketOrderId)
  const browseMode = useSelector(getMenuBrowseCTAShow)
  const { recommendationId } = useMenuMeta()

  useEffect(() => {
    const identifier = uuid()

    const collectionName = collection?.slug ?? ''
    const indexOfCollection = collection?.index ?? 0
    const deliveryDayId = boxSummaryDeliveryDays.getIn([basketDate, 'id'])

    dispatch({
      type: actionTypes.RECIPES_SHOWN,
      trackingData: {
        actionType: trackingKeys.recipesShown,
        identifier,
        displayedOrder: [], // TODO: Pass in displayedOrder when we figure out how to fix character limit on analytics events
      },
    })

    dispatch({
      type: actionTypes.VIEW_RECIPE_LIST,
      trackingData: {
        actionType: trackingKeys.viewRecipeList,
        identifier,
        collectionId,
        collectionName,
        collectionPosition: indexOfCollection + 1,
        deliveryDayId,
        orderId,
        browseMode,
        recommendationId,
        currentMenuId,
        transactionType,
      },
    })
  }, [
    dispatch,
    collectionId,
    collection,
    basketDate,
    boxSummaryDeliveryDays,
    transactionType,
    currentMenuId,
    orderId,
    browseMode,
    recommendationId,
    recipes,
  ])
}
